<template>
  <div class="account-container">
    <div class="tabs">
      <div :class="{'item':true, active: activeTab === 0}" @click="activeTab = 0">扫码对账单</div>
      <div :class="{'item':true, active: activeTab === 1}" @click="activeTab = 1">刷卡对账单</div>
    </div>
    <div class="content">
      <div class="time">
        <el-row :gutter="20">
          <el-col :span="1.5">
            <div class="label">对账日期</div>
          </el-col>
          <el-col :span="18">
            <cumstom-date-time-range @change="changeDateRange"></cumstom-date-time-range>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="shopType">
          <el-col :span="1.5">
            <div class="label">选择门店</div>
          </el-col>
          <el-col :span="1">
            <custom-select v-model="formEntity.selectedMerchantId" :list="shopList"></custom-select>
          </el-col>
        </el-row>
      </div>
      <div class="setting">
        <div class="tips">
          <div class="word">导出设置 <span>(结算信息包含费率、手续费、结算金额，每天上午5点可导出前一天的账单)</span></div>
          <div class='btn-group'>
            <el-button class="settingBtn" @click="goSettingHeader">设置表头</el-button>
            <el-button class="settingBtn" @click="doShowExportDialog">导出数据</el-button>
            <div @click="goShowExportDialog">导出记录</div>
          </div>
        </div>
        <section :class="{'edit-section': true, edit: isEdit}" v-loading="loading">
          <div class="item">
            <p class="title">表头设置</p>
            <div class="row">
              <div :class="{btn:true, active: item.checked}"  v-for="(item, index) in tableHeader.detailHeader" :key="item.code" @click="doCheckedDetailHeader(index, item)">
                <span>{{item.name}}</span>
                <div class="mark">
                  <i class="el-icon-check"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <p class="title">汇总数据设置</p>
            <div class="row">
              <div :class="{btn:true, active: item.checked}" v-for="(item, index) in tableHeader.summaryHeader" :key="item.code" @click="doCheckedSummarylHeader(index, item)">
                <span>{{item.name}}</span>
                <div class="mark">
                  <i class="el-icon-check"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="mask" v-if="!isEdit"></div>
        </section>

        <div class="edit-btn-group">
          <el-button class="save-btn" @click="doSaveHeader" v-if="isEdit">保存</el-button>
          <el-button class="cancel-btn" @click="doCancelHeader" v-if="isEdit">取消</el-button>
        </div>
      </div>
    </div>
    <el-dialog
      class="account-export-dialog-container"
      :visible.sync="dialogVisible"
      @close="closeDialog"
      :close-on-click-modal="false"
      append-to-body>
      <div class="header" slot="title">
        <p class="title">文件导出</p>
        <p class="tips">文件生成后将保留7天，超过时间将自动删除</p>
      </div>
      <div class="content" v-loading="tableLoading">
        <el-table
          :data="fileList"
          border
          style="width: 100%">
          <el-table-column
            align="center"
            prop="createTime"
            label="生成时间"
            width="180">
          </el-table-column>
          <el-table-column
            align="center"
            prop="fileName"
            label="文件名称"
            width="180">
          </el-table-column>
          <el-table-column
            align="center"
            prop="statusName"
            label="状态">
          </el-table-column>
          <el-table-column
            align="center"
            label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                @click="doDelete(scope.$index, scope.row)">删除</el-button>
              <el-button
                size="mini"
                type="primary"
                :style="{visibility: scope.row.status === 1 ? 'visible' : 'hidden'}"
                @click="doDownload(scope.$index, scope.row)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
         <el-col :span="24" class="paginationBox">
          <el-pagination
            v-if="page.count > 0"
            class="pagination"
            prev-text="上一页"
            next-text="下一页"
            :page-size="page.pageSize"
            layout="prev, pager,total,next"
            :total="page.count"
            :current-page="page.pageNo"
            @current-change="onChangeCurrentPage"
          >
          </el-pagination>
        </el-col>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  queryTableHeader, queryExcelList, deleteExcel, generateExcel, downLoadExcel, updateTableHeader,
} from '@/api/account';
import { queryShopList } from "@/api/merchant-info";
import { fileStatus } from '@/global-config';

import CumstomDateTimeRange from './components/CustomDateTimeRange.vue';
import CustomSelect from '@/components/CustomSelect/index.vue';
import { formatDatehour } from "@/utils/index";

export default {
  components: {
    CumstomDateTimeRange,
    CustomSelect,
  },
  data() {
    return {
      activeTab: 0,
      loading: false,
      tableLoading: false,
      isEdit: false, // 是否可以编辑表头
      dialogVisible: false,
      tableHeader: {
        detailHeader: [],
        summaryHeader: [],
        id: '',
      },
      timer: null,
      fileList: [],
      shopList: [],
      formEntity: {
        selectedMerchantId: [],
        dateTimeRange: [],
        startTime: "",
        endTime: "",
      },
      page: {
        pageNo: 1,
        count: 0,
        pageSize: 10,
      },
      shopType: 1,
    };
  },
  watch: {
    activeTab() {
      this.isEdit = false;
      this.queryTableHeader();
    },
  },
  methods: {
    // 获取门店列表
    queryShopList() {
      const params = {
        userName: "",
        merchantName: "",
        merchantId: "",
        pageNo: 1,
        pageSize: 1000,
      };
      return queryShopList(params).then((res) => {
        if (res.data.error_code === 0) {
          res.data.data.list.unshift({ merchantId: '@', merchantName: '全部门店', checked: true });
          this.shopList = res.data.data.list;
          this.formEntity.selectedMerchantId = [this.shopList[0].merchantId];
        }
      });
    },
    goSettingHeader() {
      this.isEdit = true;
    },
    doCancelHeader() {
      this.isEdit = false;
      this.queryTableHeader();
    },
    doSaveHeader() {
      const params = {
        id: this.tableHeader.id,
        detailHeaderList: [],
        totalHeaderList: [],
      };
      this.tableHeader.detailHeader.forEach((v) => {
        if (v.checked) {
          params.detailHeaderList.push(v.code);
        }
      });
      this.tableHeader.summaryHeader.forEach((v) => {
        if (v.checked) {
          params.totalHeaderList.push(v.code);
        }
      });
      updateTableHeader(params).then((res) => {
        if (res.data.error_code === 0) {
          this.$message({
            message: '保存成功！',
            type: 'success',
          });
          this.isEdit = false;
          this.queryTableHeader();
        }
      });
    },
    doCheckedDetailHeader(index, item) {
      item.checked = !item.checked;
      this.tableHeader.detailHeader.splice(index, 1, item);
    },
    doCheckedSummarylHeader(index, item) {
      item.checked = !item.checked;
      this.tableHeader.summaryHeader.splice(index, 1, item);
    },
    doDownload(index, row) {
      downLoadExcel(row.id);
    },
    doDelete(index, row) {
      deleteExcel({ id: row.id }).then((res) => {
        if (res.data.error_code === 0) {
          this.$message({
            message: '删除成功！',
            type: 'success',
          });
          this.queryExcelList();
        }
      });
    },
    queryTableHeader() {
      this.loading = true;
      queryTableHeader().then((res) => {
        if (res.data.error_code === 0) {
          this.tableHeader.detailHeader = res.data.data.detailHeader;
          this.tableHeader.summaryHeader = res.data.data.totalHeader;

          this.tableHeader.id = res.data.data.id;
        }
        // 让用户可以更好的感受tab切换效果
        setTimeout(() => {
          this.loading = false;
        }, 100);
      });
    },
    changeDateRange(dateTimeRange) {
      this.formEntity.startTime = formatDatehour(dateTimeRange[0]);
      this.formEntity.endTime = formatDatehour(dateTimeRange[1]);
      // this.formEntity.dateTimeRange = dateTimeRange;
    },
    queryExcelList() {
      this.tableLoading = true;
      const param = Object.assign({
        exportType: this.activeTab,
      }, this.page);
      queryExcelList(param).then((res) => {
        if (res.data.error_code === 0) {
          // 如果所有文件状态都不是等待中，就取消轮训
          let isCancel = true;
          res.data.data.list.forEach((v) => {
            v.statusName = fileStatus[v.status];
            if (v.status === 0) {
              isCancel = false;
            }
          });
          if (isCancel) {
            clearInterval(this.timer);
          }
          this.fileList = res.data.data.list;
          this.page.count = res.data.data.total;
        }
        this.tableLoading = false;
      });
    },
    // 分页
    onChangeCurrentPage(page) {
      this.page.pageNo = page;
      this.queryExcelList();
    },
    generateExcel() {
      // 进入文件导出列表页面，先请求文件列表
      // this.queryExcelList();
      const excludeDetailList = [];
      const excludeTotalList = [];
      this.tableHeader.detailHeader.forEach((v) => {
        if (v.checked !== true) {
          excludeDetailList.push(v.code);
        }
      });
      this.tableHeader.summaryHeader.forEach((v) => {
        if (v.checked !== true) {
          excludeTotalList.push(v.code);
        }
      });
      const params = {
        exportType: this.activeTab,
        startTime: this.formEntity.startTime,
        endTime: this.formEntity.endTime,
        merchantIdList: this.formEntity.selectedMerchantId,
        excludeDetailList,
        excludeTotalList,
      };
      // 如果是全部门店，需要遍历获取所有的门店id
      if (this.formEntity.selectedMerchantId[0] === '@') {
        params.merchantIdList = [];
        this.shopList.forEach((v) => {
          if (v.merchantId !== '@') {
            params.merchantIdList.push(v.merchantId);
          }
        });
      }

      // 生成文件成功后，立即查询文件列表，这样可以看到刚刚正在生成的文件的状态，让用户知道
      generateExcel(params).then((res) => {
        if (res.data.error_code === 0) {
          this.queryExcelList();

          // 每隔5秒后轮训请求文件列表，看文件导出的状态，如果文件已经生成的话，停止轮训
          this.timer = setInterval(() => {
            this.queryExcelList();
          }, 5000);
        } else {
          this.queryExcelList();
        }
      });
    },
    doShowExportDialog() {
      if (this.isEdit) {
        this.$message({
          showClose: true,
          message: "请先保存表头设置",
          type: "warning",
        });
        return;
      }
      // 判断是否选择了门店
      if (this.formEntity.selectedMerchantId.length === 0) {
        this.$message({
          showClose: true,
          message: "请选择门店",
          type: "error",
        });
      } else {
        this.page.pageNo = 1;
        this.dialogVisible = true;
        this.generateExcel();
      }
    },
    goShowExportDialog() {
      if (this.isEdit) {
        this.$message({
          showClose: true,
          message: "请先保存表头设置",
          type: "warning",
        });
        return;
      }
      this.dialogVisible = true;
      this.queryExcelList();

      // 每隔5秒后轮训请求文件列表，看文件导出的状态，如果文件已经生成的话，停止轮训
      this.timer = setInterval(() => {
        this.queryExcelList();
      }, 5000);
    },
    closeDialog() {
      clearInterval(this.timer);
    },
  },
  created() {
    this.queryTableHeader();
    this.queryShopList();
    if (JSON.parse(window.localStorage.getItem('LOGIN_INFO'))) {
      this.shopType = JSON.parse(window.localStorage.getItem('LOGIN_INFO')).shopType;
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style lang="scss">
.account-container {
  background-color: #F7F7F7;
  .tabs {
    padding-left: 50px;
    background-color: #fff;
    display: flex;
    border-bottom: 1px solid #F2F3F3;
    height: 80px;
    align-items: center;
    .item {
      height: 80px;
      line-height: 80px;
      cursor: pointer;
      color: #333333;
      font-size: 18px;
      margin-right: 60px;
      &.active {
        border-bottom: 2px solid #FF9600;
      }
    }
  }
  > .content {
    .label {
      font-size: 14px;
      width: 80px;
    }
    > .time {
      background-color: #fff;
      margin-bottom: 20px;
      padding: 40px 0 20px 50px;
      > .el-row {
        // margin:0!important;
        margin-bottom: 20px;
        &:last-child {
          padding-top: 20px;
        }
        .el-col {
          .label {
            height: 32px;
            line-height: 32px;
          }
        }
      }
    }
    .setting {
      background-color: #fff;
      padding-left: 50px;
      position: relative;
      .settingBtn{
        line-height: 0px;
      }
      .tips {
        height: 70px;
        line-height: 70px;
        color: #333333;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        &:after {
          content: '';
          display: block;
          position: absolute;
          bottom: 0px;
          height: 0px;
          border-bottom: 1px solid #EAEAEA;
          left: -50px;
          right: 0;
        }
        .word {
          span {
            color: #666666;
            font-size: 14px;
          }
        }
        .btn-group {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin-right: 50px;
          .el-button {
            margin-right: 20px;
            width: 120px;
            height: 32px;
            background-color: #FF9C00;
            color: #fff;
            border: none;
          }
          div {
            cursor: pointer;
            font-size: 14px;
          }
        }
      }
      .edit-section {
        position: relative;
        margin-right: 10px;
        .mask {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
        }
        &.edit {
          border: 1px solid #FF9600;
          padding-left: 10px;
        }
      }
      .item {
        .title {
          color: #000000;
          font-size: 18px;
          padding-top: 40px;
          padding-bottom: 26px;
        }
        .row {
          display: flex;
          flex-wrap: wrap;
          .btn {
            cursor: pointer;
            margin-right: 20px;
            margin-bottom: 20px;
            border-radius: 2px;
            border: 1px solid #DFDFDF;
            width: 130px;
            line-height: 32px;
            text-align: center;
            height: 32px;
            color: #666666;
            position: relative;
            &.active {
              border: 1px solid #FF9600;
              color: #FF9600;
              .mark {
                border-bottom-color: #FF9600;
                border-right-color: #FF9600;
              }
            }
            .mark {
              width: 0;
              height: 0;
              border: 12px solid #DFDFDF;
              border-top-color: transparent;
              border-left-color: transparent;
              position: absolute;
              right: 0;
              bottom: 0;
              i {
                position: absolute;
                font-size: 8px;
                color: #fff;
              }
            }
          }
        }
      }
      > .edit-btn-group {
        margin: 50px auto;
        text-align: center;
        // position: absolute;
        // bottom: -80px;
        // left: 50%;
        // margin-left: -25px;
        // transform: translateX(-50%);
        .save-btn {
          background-color: #FF9C00;
          color: #fff;
          border: none;
          width: 120px;
          height: 32px;
          line-height: 0px;
        }
        .cancel-btn{
          width: 120px;
          height: 32px;
          line-height: 0px;
        }
      }
    }
  }
}
.account-export-dialog-container {
  .el-dialog__header {
    padding: 40px 40px 0 40px;
    .title {
      color: #333333;
      font-size: 22px;
    }
    .tips {
      padding-top: 10px;
      color: #666666;
      font-size: 14px;
    }
  }
  .el-dialog__body {
    padding: 60px 40px;
    overflow: hidden;
  }
}
</style>
